import { useQuery } from '@tanstack/react-query'
import { request } from '@/utils/axiosUtil'

export default function useSearchSpeakersByTextService(reqBody) {
  const isLongEnough = reqBody?.text?.length >= 2
  const getSearchSpeakersByText = async (reqBody) => {
    const apiUrl = `/unifiedAutoPopulate?query=${encodeURIComponent(reqBody.text)}`

    const res = await request({ url: apiUrl })
    if (res?.status == 200) {
      return res?.data?.data
    } else {
      return res?.response?.data
    }
  }

  return useQuery(
    reqBody && ['searchSpeakersByTextService', reqBody],
    () => getSearchSpeakersByText(reqBody),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: isLongEnough,
    }
  )
}
